module.exports = __webpack_public_path__ + "img/QAR.4090603d.svg";